import React from "react";
import { AddCustodianContainer } from "../../../containers";

const AddCustodian = (props) => {
  return <AddCustodianContainer {...props} />;
};

export default AddCustodian;
